
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/colours",
      function () {
        return require("private-next-pages/en/colours/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/colours"])
      });
    }
  